module.exports = __webpack_public_path__ + "img/cg_old1.cd466d41.png";